import React from "react";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import axiosWithToken from "./axiosTokenConfig";
import { BASE_URL } from "../../global";

const ImageUploadCommonButton = ({ url, updateUrl, disabled, label = "Upload Signature", imgShow = false }) => {
  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only image files (JPG, PNG, WEBP) are allowed!");
      return;
    }

    const data = new FormData();
    data.append("fileToUpload", file);

    try {
      const res = await axiosWithToken.post(BASE_URL + "fileUpload/fileUpload.php", data);
      if (res.status === 200) {
        updateUrl(res.data);
        toast.success("Image uploaded successfully!");
      }
    } catch (err) {
      toast.error("Upload failed!");
    }
  };

  const handleClear = () => {
    updateUrl("");
  };

  return (
    <div className="flex flex-col items-center gap-2">
    {imgShow && (
        <>
          {url ? (
            <img
              src={url}
              alt="signature"
              style={{ maxHeight: 100, maxWidth: 200, objectFit: "contain" }}
            />
          ) : (
            <div className="w-[200px] h-[80px] border border-dashed border-gray-300 flex items-center justify-center text-gray-400 text-xs">
              No image
            </div>
          )}
        </>
    )}

      {!disabled && (
        <div className="flex gap-2">
          <>
            <input
              id={`img-upload-${label}`}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleUpload}
            />
            <label htmlFor={`img-upload-${label}`}>
              <Button variant="outlined" component="span" size="small">{label}</Button>
            </label>
          </>
          {url && (
            <Button variant="outlined" color="error" size="small" onClick={handleClear}>Clear</Button>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageUploadCommonButton;